import { render, staticRenderFns } from "./aftermarket.vue?vue&type=template&id=1806af62"
import script from "./aftermarket.vue?vue&type=script&lang=js"
export * from "./aftermarket.vue?vue&type=script&lang=js"
import style0 from "./aftermarket.vue?vue&type=style&index=0&id=1806af62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports